import '../../../types/date.extension';

import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {App} from './app/app';
// Import with `import * as Sentry from "@sentry/angular"` if you are using ESM
import * as Sentry from '@sentry/angular';
import {isDevMode} from '@angular/core';
import {environment} from './environments/environment';

if (environment.SENTRY_DSN) {
  Sentry.init({
    dsn: environment.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing must be enabled for agent monitoring to work
    tracesSampleRate: 1.0,
    // Add data like inputs and responses to/from LLMs and tools;
    // see https://docs.sentry.io/platforms/javascript/data-management/data-collected/ for more info
    sendDefaultPii: true, // вмикай лише якщо тобі це реально потрібно
    environment: isDevMode() ? 'development' : 'production',
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
